import React from 'react';
const IconMiscCloudCheckFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.43 9.54C18.96 5.82 15.82 3 12 3C9.12 3 6.62 4.61 5.37 7H9V9H7C6.13 9 5.31 9.19 4.57 9.53V9.54C2.41 10.49 1 12.61 1 15C1 18.31 3.69 21 7 21H17C20.31 21 23 18.31 23 15C23 12.61 21.59 10.49 19.43 9.54ZM11.5 17.41L8.29 14.2L9.7 12.79L11.49 14.58L15.28 10.79L16.69 12.2L11.5 17.41Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscCloudCheckFill;